/* eslint-disable no-undef */
import $ from "jquery";

const clearCart = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".CartPage .Cart__Main button[name='empty_cart']",
      page: ".CartPage",
      counterEl: ".js-counter-cart",
      minicart: "#js-minicart",
      confirmPopup: ".js-confirmation-remove-cart",
      buttonYes: ".js-popup-button-yes",
      buttonNo: ".js-popup-button-no",
    };

    let isClearAll = false;

    if ($(el.page).length === 0) return;

    // open popup in minicart components
    $(document).on("click", el.button, function (e) {
      e.preventDefault();

      $(el.confirmPopup).show();
      $('body').css('overflow-x', 'hidden');
      isClearAll = true;
    });

    // cancel delete
    $(document).on("click", el.buttonNo, function (e) {
      e.preventDefault();

      $(el.confirmPopup).hide();
      $('body').css('overflow-x', 'unset');
      isClearAll = false;
    })

    $(document).on("click", el.buttonYes, function (e) {
      e.preventDefault();

      if (isClearAll) {
        $.ajax({
          type: 'POST',
          url: themeObj.ajaxUrl, // Use the correct AJAX URL here
          data: {
            action: themeObj.removeAllItemCart.action,
            nonce: themeObj.removeAllItemCart.nonce,
          },
          beforeSend() {
            $(el.button).attr("disabled", "disabled");
            $(el.buttonYes).find('.loading').show();
            $(el.buttonYes).find('.text').hide();
          },
          success() {
            jQuery(document.body).trigger("wc_fragment_refresh");
            location.reload();
          },
          error() {
            // eslint-disable-next-line no-console
            console.log('Error clearing your shopping cart.');
          },
          complete() {
          },
        });
      }
    });
  };

  init();
};

try {
  clearCart();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error(error);
}
